import MicroModal from '../vendor/micromodal.js';
import {ANIMATIONS, createAnimation, playAnimation, stopAnimation} from './animation.js';
import {imagesData} from './data/data-values.js';

const DASH_OFFSET = 207;
const VALUE_ITEM_CLASS = `.values__list-item`;
const FIRST_VALUE_SELECTOR = `.values__list-item:first-child`;
const DETAILS_LIST_CLASS = `.values__details-list`;
const BUTTON_NEXT_CLASS = `.values__next-button`;
const BUTTON_PREV_CLASS = `.values__prev-button`;
const BUTTON_NEXT_FINAL_CLASS = `.values__next-button--final`;
const BUTTON_PREV_FINAL_CLASS = `.values__prev-button--final`;
const PROGRESS_ITEM_CLASS = `.values__progress-item`;
const PROGRESS_CIRCLE_CLASS = `.values__circle-2`;
const PROGRESS_BAR_CLASS = `.values__progress-bar`;
const HIDDEN = `hidden`;
const PAGINATION_CONTAINER_CLASS = `.values__pagination`;
const PAGE_NUMBER_CLASS = `values__page`;
const MODAL_CONTENT_CLASS = `.values__modal-content`;
const VALUES = `--1`;
const FINAL = `--2`;
const FINAL_ITEM_CLASS = `.values__final-item`;
const CONTROLS_CLASS = `.values__controls`;
const CONTROLS_FINAL_CLASS = `.values__controls--final`;
const PROGRESS_CLASS = `.values__progress-list`;
const HEADING_CLASS = `.values__list-item h3`;
const FINAL_TEXT_CLASS = `.values__final-item p`;
const FINAL_LETTER_CLASS = `.values__letter`;
const FINAL_ITEM_IMG_CLASS = `.values__item`;
const FIGURE_CLASS = `.values__figure`;

const figuresList = [
  `<svg class="values__figure values__figure--1 lazyload" viewBox="571.012 185.108 800 720" xmlns="http://www.w3.org/2000/svg"> <g class="cls-1" transform="matrix(1, 0, 0, 1, 11.65705, 10.239058)"> <g class="shadow hidden"> <path class="cls-2" d="M987.49,884.63l136.8-8.43a83.38,83.38,0,0,0,39.43-10.43L1337.3,763.66a21,21,0,0,0-1.29-36.95l-142.58-72.07a33.54,33.54,0,0,0-32.91,1.7l-66,41.86Z"/> </g> <g class="object-item object-item-1 hidden"> <polygon class="cls-3" points="608.71 664.29 740.19 436.57 871.62 512.55 871.66 512.48 871.66 512.48 871.69 512.42 1004.03 284.24 1251.02 426.96 987.62 883.36 608.71 664.29"/> <polygon class="cls-4" points="724.22 731.11 855.7 503.39 987.13 579.37 987.17 579.29 987.17 579.29 987.21 579.24 1119.54 351.06 1251.02 426.96 987.62 883.36 724.22 731.11"/> </g> <g class="object-item object-item-2 hidden"> <path class="cls-3" d="M1135,360.21l-40.21-23.52L962.5,564.8,824.24,485.19,989.78,198.87a27.54,27.54,0,0,1,37.62-10.07l154.95,89.45Z"/> <path class="cls-4" d="M1251,427l-131.48-75.9L987.13,579.37l-47-27.24,165.62-286.51a27.54,27.54,0,0,1,37.62-10.07l131.1,75.68a27.54,27.54,0,0,1,10.08,37.62Z"/> </g> <g class="object-item object-item-3 hidden"> <path class="cls-3" d="M871.18,512.54l-46.43-27.83-125.25,232-114.68-66a27.54,27.54,0,0,1-10.12-37.64L725.94,351.2a27.52,27.52,0,0,1,37.61-10.07l155,89.45Z"/> <path class="cls-4" d="M940.15,552.13,855.7,503.39,724.22,731.11l-23.47-13.55a27.55,27.55,0,0,1-10.08-37.62L841.93,418a27.54,27.54,0,0,1,37.62-10.07l107.92,62.28Z"/> </g> </g> </svg>`,
  `<svg class="values__figure values__figure--2 lazyload" viewBox="526.506 136.165 886 827" xmlns="http://www.w3.org/2000/svg"> <g class="cls-1" transform="matrix(1, 0, 0, 1, 9.507587, 9.645209)"> <g class="shadow hidden"> <g id="shadow-2" data-name="shadow"> <path class="cls-2" d="M960,943.84h53.29l113.36-5.52a102.32,102.32,0,0,0,46.28-13.64l154.76-89.58,56.18-32.69a19.36,19.36,0,0,0,.21-33.34L1223.54,672a36.83,36.83,0,0,0-34.49-1.8L1081.73,733Z"/> </g> </g> <g class="object-item object-item-1 hidden"> <polyline class="cls-3" points="956.69 613.58 956.69 674.98 921.72 693.97 921.72 782.39 802.68 851.06"/> <path class="cls-4" d="M667.83,774.44l342.7-198.16,133.93,77.51c-5.35,9.24-313.2,215.37-322.44,210Z"/> <path class="cls-5" d="M801.75,852l342.71-198.16L982.37,934.26a19.33,19.33,0,0,1-26.42,7Z"/> </g> <g class="object-item object-item-2 hidden"> <path class="cls-4" d="M1226.31,221.24l-142-82.29a20.8,20.8,0,0,0-28.42,7.63L870.59,467.73l134.28,76.8,227.94-299A17.76,17.76,0,0,0,1226.31,221.24Z"/> <path class="cls-5" d="M1336.91,285.13,1218.1,216.54a20.8,20.8,0,0,0-28.42,7.63L1004.87,544.53l-.45,190.23,140-81,199-344.38A17.77,17.77,0,0,0,1336.91,285.13Z"/> <polygon class="cls-4" points="870.59 467.67 1004.41 545.25 1004.41 734.76 870.59 657.17 870.59 467.67"/> </g> <g class="object-item object-item-3 hidden"> <polygon class="cls-4" points="1004.87 544.53 870.59 467.73 788 610.9 922.27 687.7 1004.87 544.53"/> <path class="cls-4" d="M680.26,454.83a20.8,20.8,0,0,0-28.36,7.62l-123,212.34a17.76,17.76,0,0,0,6.51,24.3L668,775.1l154.94-89.59V536.73Z"/> <path class="cls-5" d="M814,531.68a20.8,20.8,0,0,0-28.36,7.62l-123,212.34A17.78,17.78,0,0,0,669.19,776l132.56,76,202.67-117.19.45-190.23-38.6,66.8a6.58,6.58,0,0,1-9,2.42Z"/> </g> </g> </svg>`,
  `<svg class="values__figure values__figure--3 lazyload" viewBox="562.774 135.262 994 827" xmlns="http://www.w3.org/2000/svg"> <g class="shadow hidden"><path class="cls-1" d="M866.16,942.73h188.77a74.33,74.33,0,0,0,37.18-10l437-252.4a16.16,16.16,0,0,0,0-28L1341.74,544.52a21.89,21.89,0,0,0-21.9,0l-40.72,23.6,1,118.79a36.2,36.2,0,0,1-18.34,31.77l-395.6,224"/> </g> <g class="object-item object-item-1 hidden"> <path class="cls-2" d="M860.77,940.73l358-275,60-222-159.39-91.88L1049.85,392V458.3l-95.71,55.26v77.36l-113,66.31L696.56,740.12v99.1a11.4,11.4,0,0,0,5.27,9.68C705.26,851.11,860.77,940.73,860.77,940.73Z"/> <path class="cls-3" d="M872.86,941.21l393.68-227.29a23.69,23.69,0,0,0,11.84-20.5V443.85L1208.85,484V550.3l-95.71,55.26v77.36l-113,66.31L855.56,832.12v99.1A11.53,11.53,0,0,0,872.86,941.21Z"/> <polygon class="cls-4" points="855.56 832.12 696.56 740.12 954.14 590.92 1113.14 682.92 855.56 832.12"/> <polygon class="cls-4" points="1113.14 605.56 954.14 513.56 1049.85 458.3 1208.85 550.3 1113.14 605.56"/> <polygon class="cls-4" points="1208.85 483.99 1049.85 391.99 1119.38 351.85 1278.38 443.85 1208.85 483.99"/> </g> <g class="object-item object-item-2 hidden"> <path class="cls-2" d="M1064.77,577.73l210-348S1117.11,139,1113.9,137a11.43,11.43,0,0,0-11.82-.18l-136,78.5c-7,4-12.7,13.94-12.7,22h0c0,3.88,1.42,6.67,3.7,8.2,15.58,10.52,22.63,35.21,13.94,70.4a145.58,145.58,0,0,1-41.78,71.26c-46,43-88.14,28.11-88.14-22.49v292.5l158.64,91.5Z"/> <path class="cls-3" d="M1113.14,605.56l95.71-55.26V484l69.53-40.13v-205a11.53,11.53,0,0,0-17.3-10l-136,78.5c-7,4-12.7,13.94-12.7,22h0c0,3.88,1.42,6.67,3.7,8.2,15.58,10.52,22.63,35.21,13.94,70.4a145.58,145.58,0,0,1-41.78,71.26c-46,43-88.14,28.11-88.14-22.49v292.5l113-66.31Z"/> <line class="cls-2" x1="957.11" y1="245.56" x2="1116.11" y2="337.56"/> <polygon class="cls-2" points="841.13 364.73 1000.13 456.73 1000.13 749.23 841.13 657.23 841.13 364.73"/> </g> <g class="object-item object-item-3 hidden"> <polygon class="cls-2" points="855.56 832.12 790.23 794.89 850.53 741.29 873.86 754.76 855.56 832.12"/> <path class="cls-2" d="M744.07,832.09l-47.61-27.15,47.31,26.79c34.32-89.42,59.85-92,63-90,3.42,2.16,96,24,96,24l114.91-392s-158.57-92-160-92.49c-2.4-.8-5.49-.22-8.64,1.6L708.3,364.08a23.67,23.67,0,0,0-11.84,20.5V551c0,7-5,15.68-11.09,19.2l-4.56,2.63c-2.76,1.6-5.37,1.82-7.46.94-11.72-5-27-3.26-43.73,6.4C592.07,601.8,561.76,655,562.8,698.06c.45,18.52,7,32,17.35,39.19C592.87,746.13,744.07,832.09,744.07,832.09Z"/> <line class="cls-2" x1="832.46" y1="665.79" x2="673.35" y2="573.72"/> <path class="cls-3" d="M1000.13,456.73h0c0-20.16,6.73-42.36,17.7-62.43,3.49-6.37,5-13.38,2.41-18.05-2.19-4-7.06-4.27-12.11-1.35L867.4,456.15a23.68,23.68,0,0,0-11.84,20.5V643c0,7-5,15.68-11.08,19.2l-4.56,2.63c-2.77,1.6-5.37,1.82-7.46.94-11.72-5-27-3.26-43.74,6.4-37.54,21.67-67.86,74.92-66.81,117.94,1,41.27,32.29,57.39,68.54,35.4,17.95-10.89,34.12-29,45.87-49.51a23.8,23.8,0,0,1,8.16-8.86c6.1-3.52,11.08-.64,11.08,6.39v58.57l144.57-82.89V456.73Z"/> <polygon class="cls-3" points="1000.13 456.73 1000.13 456.73 1000.13 456.73 1000.13 456.73"/> </g> </svg>`,
  `<svg class="values__figure values__figure--4 lazyload" viewBox="677.806 136.195 605 830" xmlns="http://www.w3.org/2000/svg"> <g class="cls-1" transform="matrix(1, 0, 0, 1, 9.9599, 11.177284)"> <g class="shadow hidden"> <path data-name="shadow" class="cls-2" d="M886.37,943.84h127.46a72.2,72.2,0,0,0,36.19-9.72l205.57-118.91a14.64,14.64,0,0,0,0-25.33L1062.91,678.4V828.91a27.18,27.18,0,0,1-13.88,23.7Z"/> </g> <g class="object-item object-item-1 hidden"> <path class="cls-3" d="M879.89,936.07l-.53-190.74L757.58,676.92,758.14,865a10,10,0,0,0,5,8.65L883.44,943a8.07,8.07,0,0,1-3.55-6.95"/> <path class="cls-4" d="M1062.91,829.58c0,7.69-5.4,17.07-12.09,20.94L892.07,942.17c-6.7,3.87-12.15.76-12.17-6.93l-.54-189.91,183-110.52Z"/> <polygon class="cls-3" points="757.58 676.92 943.3 566.06 1062.36 634.81 879.36 745.33 757.58 676.92"/> </g> <g class="object-item object-item-2 hidden"> <polygon class="cls-3" points="885.17 471.14 1004.98 540 1004.98 235.78 885.17 165.82 885.17 171.31 885.17 471.14"/> <polygon class="cls-3" points="942.55 565.95 942.55 565.95 942.55 565.95 942.55 565.95"/> <path class="cls-4" d="M1005,540l-67,37.39V709.9l124.33-75.09-.51-177.38c0-7.7,5.4-17.08,12.1-20.94l54.94-31.73c9.8-5.66,15.53-21.7,9.86-27.69L1005,235.78V540Z"/> <polygon class="cls-4" points="1062.36 634.81 1062.36 634.81 1062.36 634.81 1062.36 634.81"/> <polygon class="cls-4" points="938.03 709.9 938.03 709.9 1062.36 634.81 1062.36 634.81 938.03 709.9"/> <polygon class="cls-3" points="818.22 641.04 938.03 709.9 938.03 577.39 818.22 508.53 818.22 641.04"/> <polygon class="cls-3" points="818.22 508.53 885.17 471.14 1004.98 540 938.03 577.39 818.22 508.53"/> </g> <g class="object-item object-item-3 hidden"> <polygon class="cls-3" points="879.36 745.33 878.84 563.09 879.13 555.46 757.09 492.34 757.61 676.94 879.36 745.33"/> <path class="cls-3" d="M856.33,137c-2.36-1.37-5.48-.93-8.59.86a25.72,25.72,0,0,0-9.91,11.68L680,500.89c-3.62,8.07-2.49,14.85,1.41,17.11l121.76,70.76c-3.9-2.27-5-9-1.41-17.12l167.75-363c3.12-1.8,6.24-2.23,8.59-.87Z"/> <path class="cls-4" d="M938,577.39,1005,540V235.78l-25.54-27c-2.42-2.58-6.19-2.39-10-.22a25.66,25.66,0,0,0-9.91,11.68L801.74,571.64c-5.61,12.5.18,21.9,10,16.24l54.94-31.72c6.7-3.87,12.15-.76,12.17,6.93l.52,182.24L938,709.9Z"/> </g> </g> </svg>`,
  `<svg class="values__figure values__figure--5 lazyload" viewBox="586.947 136.144 831 827" xmlns="http://www.w3.org/2000/svg"> <g class="cls-1" transform="matrix(1, 0, 0, 1, 9.817636, 9.693774)"> <g class="shadow hidden"> <path data-name="shadow" class="cls-2" d="M825,942l174.25-2.49a70.18,70.18,0,0,0,31.84-9.33l362.35-209.48a9.74,9.74,0,0,0,.09-16.82l-160.76-92.39a41.44,41.44,0,0,0-41.59.17L965.1,744.06Z"/> </g> <g class="object-item object-item-1 hidden"> <path class="cls-3" d="M709.74,707.36,690.4,858.74a9,9,0,0,0,5.39,9.58C699.21,869.84,825,942,825,942l15.65-159.59Z"/> <path class="cls-4" d="M837.48,940.6,998.56,753a14,14,0,0,1,10.94-4.87l170.41,4.22a14.57,14.57,0,0,0,14.76-16.74l-32.36-214-106.6,61.84V658.4l-215,124-19.3,151.05A9.2,9.2,0,0,0,837.48,940.6Z"/> <polygon class="cls-3" points="709.74 707.36 923.78 582.26 1055.71 658.4 840.67 782.39 709.74 707.36"/> <polygon class="cls-3" points="924.78 508.43 923.78 582.26 1055.71 658.4 1055.71 583.45 924.78 508.43"/> <polygon class="cls-3" points="924.78 508.43 1030.37 445.47 1162.31 521.61 1055.71 583.45 924.78 508.43"/> </g> <g class="object-item object-item-2 hidden"> <path class="cls-3" d="M1289.65,283.86l-131-74.68a9.64,9.64,0,0,0-8.53-.55L978.22,277.27a12.75,12.75,0,0,1-15.83-5.55V376.15L790.71,475.62V661h0l131,74.68Z"/> <path class="cls-4" d="M1055.71,583.45l106.6-61.84,131-224.14a9.88,9.88,0,0,0-12.19-14.16L1109.22,352a12.74,12.74,0,0,1-15.82-5.55l-25.71-45.28-.56,164.93L921.71,550.3V735.66h0l134-77.26Z"/> <polygon class="cls-3" points="921.72 550.3 790.71 475.62 936.13 391.37 1067.13 466.05 921.72 550.3"/> <polygon class="cls-3" points="1067.13 301.12 936.13 226.44 936.13 391.31 1067.13 465.99 1067.13 301.12"/> </g> <g class="object-item object-item-3 hidden"> <path class="cls-3" d="M1031.34,446.91l-23.28-21.29s48.72-57.17,47.65-57.68c-2.28-1.09-45.05-26.33-47.85-25.21l-13.62-71.86c-5.92,2.37,21.13-58.27,21.13-58.27s-129.6-74.1-131.9-75.19a13.23,13.23,0,0,0-18.27,8l-75.58,238.7a25.31,25.31,0,0,1-9.51,13l-187,132a14.56,14.56,0,0,0,1.25,24.58l125.95,71-10.56,82.67,130.93,75,26.92-104.13a14,14,0,0,1,10.94-4.86l4.9-112c9.05.22,77.92-85,76.57-93.94Z"/> <line class="cls-4" x1="785.58" y1="393.91" x2="914.54" y2="468.83"/> <path class="cls-4" d="M921.71,550.3l145.42-84.25.56-164.93-47.45-83.57a13.2,13.2,0,0,0-24.06,2.53l-75.59,238.7a25.28,25.28,0,0,1-9.51,13l-187,132a14.56,14.56,0,0,0,1.25,24.58l125.95,71-10.6,83,81.05-46.73h0Z"/> </g> </g> </svg>`,
];

const animateCSS = (element, animationClasses, toggleVisibility = false, prefix = `animate__`) =>
  new Promise((resolve) => {
    const animations = animationClasses.split(` `).map((animation) => `${prefix}${animation}`);
    const isHidden = element.classList.contains(HIDDEN);

    if (toggleVisibility && isHidden) {
      element.classList.remove(HIDDEN);
    }

    function handleAnimationEnd() {
      element.classList.remove(`${prefix}animated`, ...animations);
      element.removeEventListener(`animationend`, handleAnimationEnd);

      if (toggleVisibility && !isHidden) {
        element.classList.add(HIDDEN);
      }

      resolve(`Animation ended`);
    }

    element.addEventListener(`animationend`, handleAnimationEnd);
    element.classList.add(`${prefix}animated`, ...animations);
  });

const hide = (elements) => {
  elements.forEach((item) => toggleClass(item, HIDDEN));
};

const hideLists = (lists) => {
  lists.forEach((list) => {
    const term = list.querySelector(`dt`);
    const items = list.querySelectorAll(`dd`);

    toggleClass(list, HIDDEN);
    toggleClass(term, HIDDEN);
    hide(items);
  });
};

const setButtonProgress = (step, maxSteps = 3, maxOffset = DASH_OFFSET) => {
  const stepOffset = maxOffset / maxSteps;

  progressCircle.style.strokeDashoffset = maxOffset - stepOffset * (step + 1);
};

const createPagination = (numberOfPages, isReverse = false) => {
  const visibleIndex = isReverse ? numberOfPages : 1;
  const container = document.querySelector(PAGINATION_CONTAINER_CLASS);
  container.innerHTML = ``;

  for (let i = 1; i <= numberOfPages; i++) {
    const span = document.createElement(`span`);
    span.setAttribute(`class`, i === visibleIndex ? PAGE_NUMBER_CLASS : `${PAGE_NUMBER_CLASS} ${HIDDEN}`);

    const text = document.createTextNode(`${i}/${numberOfPages}`);
    span.appendChild(text);
    container.appendChild(span);
  }

  const pageNumbers = container.querySelectorAll(`.${PAGE_NUMBER_CLASS}`);

  return pageNumbers;
};

const setStepOpacity = (index, maxSteps, listIndex) => {
  const item = progressItems[index];
  const opacity = listIndex === null ? `10%` : `${100 / maxSteps * (listIndex + 1)}%`;

  item.style.opacity = opacity;
};

const createIncrementFunction = () => {
  let currentStep = 1;

  return (step) => {
    if (step === null) {
      currentStep = 0;
    }

    currentStep += step;

    if (currentStep > lists.length) {
      return;
    }

    const stepWidth = 100 / lists.length;
    progressBar.style.width = `${stepWidth * currentStep}%`;
  };
};

const setBarProgress = createIncrementFunction();

const createImg = (data, container) => {
  const img = document.createElement(`img`);
  img.className = data.className;
  img.src = data.src.png;
  img.srcset = `${data.srcX2.png}`;
  img.width = data.width;
  img.height = data.height;
  img.alt = data.alt;

  const source1 = document.createElement(`source`);
  source1.type = `image/webp`;
  source1.media = `(min-width: 1600px)`;
  source1.srcset = `${data.srcX2.webp} 1x, ${data.srcX2.webp} 2x`;

  const source2 = document.createElement(`source`);
  source2.type = `image/webp`;
  source2.srcset = `${data.src.webp} 1x, ${data.srcX2.webp} 2x`;

  const source3 = document.createElement(`source`);
  source3.media = `(min-width: 1600px)`;
  source3.srcset = `${data.srcX2.png} 1x, ${data.srcX2.png} 2x`;

  const picture = document.createElement(`picture`);
  [source1, source2, source3, img].forEach((element) => picture.appendChild(element));

  container.appendChild(picture);
};

const showFinalScreen = () => {

  if (!finalItems) {
    Object.keys(imagesData).forEach((index) => imagesData[index].forEach((data) => createImg(data, finalValueItems[index])));
    finalItems = true;
  }

  const text = finalValueItems[0].querySelector(`p`);
  const items = finalValueItems[0].querySelectorAll(FINAL_ITEM_IMG_CLASS);
  const finalLetters = document.querySelectorAll(FINAL_LETTER_CLASS);

  if (activeAnimationFinal.length === 0) {
    activeAnimationFinal = createAnimation(ANIMATIONS.FINAL);
  }

  stopAnimation(activeAnimation[activeAnimation.length - 1]);
  playAnimation(activeAnimationFinal);

  toggleClass(finalScreen, HIDDEN);
  animateCSS(valuesScreen, `fadeOutLeft`, true)
      .then(() => animateCSS(finalValueItems[0], `slideInUp`, true))
      .then(() => animateItems(finalLetters, `fadeInDownBig`))
      .then(() => animateItems(items, `fadeInDownBig`))
      .then(() => animateCSS(text, `fadeInRight faster`, true))
      .then(() => {
        buttonNextFinal.onclick = () => iterateFinalValues(finalValueItems, 0, false);
        buttonPrevFinal.onclick = () => iterateFinalValues(finalValueItems, 0, true);
        animateCSS(controlsFinal, `fadeIn`, true);
      });
};

const hideFinalScreen = () => {
  const items = finalValueItems[0].querySelectorAll(FINAL_ITEM_IMG_CLASS);
  const finalLetters = document.querySelectorAll(FINAL_LETTER_CLASS);
  const text = finalValueItems[0].querySelector(`p`);

  stopAnimation(activeAnimationFinal);
  playAnimation(activeAnimation[activeAnimation.length - 1]);

  animateCSS(controlsFinal, `fadeOut`, true)
      .then(() => animateCSS(text, `fadeOutLeft faster`, true))
      .then(() => animateItems(items, `fadeOutUpBig`))
      .then(() => animateItems(finalLetters, `fadeOutUpBig`))
      .then(() => animateCSS(finalValueItems[0], `slideOutDown`, true))
      .then(() => animateCSS(valuesScreen, `fadeInLeft`, true))
      .then(() => toggleClass(finalScreen, HIDDEN));
};

const showHeading = (heading) => animateCSS(heading, `fadeInRight faster`, true);

const showListContents = (list) => {
  const term = list.querySelector(`dt`);
  const items = list.querySelectorAll(`dd`);

  return animateCSS(term, `fadeInRight faster`, true)
      .then(() => {
        let delay = 0;
        items.forEach((item, index, array) => {
          setTimeout(() => {
            if (index === array.length - 1) {
              buttonNext.disabled = false;
              buttonPrev.disabled = false;
            }

            animateCSS(item, `fadeInRight faster`, true);
          }, delay);

          delay += 400;
        });
      });
};

const changeLists = (current, next) => {
  return animateCSS(current, `fadeOutLeft`).then(() => {
    hideLists([current]);
    toggleClass(next, HIDDEN);
  });
};

const changeValues = (current, next, isReverse = false) => {
  const currentLists = current.querySelectorAll(DETAILS_LIST_CLASS);
  const currentList = currentLists[isReverse ? 0 : currentLists.length - 1];
  const currentHeading = current.querySelector(`h3`);

  animateCSS(current, `fadeOutUp`, true)
      .then(() => {
        hideLists([currentList]);
        toggleClass(currentHeading, HIDDEN);
      });

  return animateCSS(next, `fadeInUp`, true)
      .then(() => {
        const lists = next.querySelectorAll(DETAILS_LIST_CLASS);
        const list = lists[isReverse ? lists.length - 1 : 0];
        const heading = next.querySelector(`h3`);
        toggleClass(list, HIDDEN);
        showHeading(heading);
        showListContents(list);
      });


};

const changePages = (current, next) => {
  animateCSS(next, `fadeIn`, true);
  animateCSS(current, `fadeOut`, true);
};

const buildFigure = (figure, index) => {
  const figureParts = figure.querySelectorAll(`.object-item`);
  const figureShadow = figure.querySelector(`.shadow`);

  if (index === 0) {
    animateCSS(figureShadow, `fadeInRight`, true);
  }

  return animateCSS(figureParts[index], `slideInDown`, true);
};

const dismountFigure = (figure, index) => {
  const figureParts = figure.querySelectorAll(`.object-item`);

  if (index === 0) {
    const figureShadow = figure.querySelector(`.shadow`);
    animateCSS(figureShadow, `fadeOut`, true);
  }

  return animateCSS(figureParts[index], `slideOutUp`, true);
};

const animateItems = (items, animationClass) => {
  const generateDelay = () => Math.floor(Math.random() * (800 - 100) + 100);

  const events = Array.from(items).map((item) =>
    new Promise((resolve) => setTimeout(resolve, generateDelay()))
        .then(() => animateCSS(item, animationClass, true)));

  return Promise.all(events);
};

const changeAnimation = (animation, index, nextIndex) => {
  if (activeAnimation[index]) {
    stopAnimation(activeAnimation[index]);
  } else {
    activeAnimation = [...activeAnimation, createAnimation(animation[index])];
    playAnimation(activeAnimation[index]);
  }

  if (!nextIndex && nextIndex !== 0) {
    return;
  }

  if (activeAnimation[nextIndex]) {
    playAnimation(activeAnimation[nextIndex]);
  } else {
    activeAnimation = [...activeAnimation, createAnimation(animation[nextIndex])];
    playAnimation(activeAnimation[nextIndex]);
  }
};

const insertFigure = (figure, parent) => {
  const element = parent.querySelector(FIGURE_CLASS);

  if (element) {
    return;
  }

  parent.insertAdjacentHTML(`beforeend`, figure);
};

const changeFinalValues = (current, next, isReverse = false) => {
  const currentText = current.querySelector(`p`);
  const currentItems = current.querySelectorAll(FINAL_ITEM_IMG_CLASS);
  const nextText = next.querySelector(`p`);
  const nextItems = next.querySelectorAll(FINAL_ITEM_IMG_CLASS);

  if (isReverse) {
    return animateCSS(currentText, `fadeOutRight faster`, true)
        .then(() => animateItems(currentItems, `fadeOutUpBig`))
        .then(() => animateCSS(nextText, `fadeInLeft faster`, true))
        .then(() => animateCSS(current, `fadeOutUpBig`, true));
  }

  if (!isReverse) {
    return animateCSS(currentText, `fadeOutLeft faster`, true)
        .then(() => animateCSS(next, `fadeInDownBig`, true))
        .then(() => animateCSS(nextText, `fadeInRight faster`, true))
        .then(() => animateItems(nextItems, `fadeInDownBig`));
  }

  return Promise.resolve();
};

const iterateFinalValues = (values, finalValueIndex, isReverse = false) => {
  const current = values[finalValueIndex];
  const next = values[isReverse ? finalValueIndex - 1 : finalValueIndex + 1];

  buttonNextFinal.disabled = true;
  buttonPrevFinal.disabled = true;

  if (finalValueIndex === 1) {
    controlsFinal.classList.add(`values__controls--final-exit`);
    buttonNextFinal.classList.add(`values__next-button--final-exit`);
  } else {
    controlsFinal.classList.remove(`values__controls--final-exit`);
    buttonNextFinal.classList.remove(`values__next-button--final-exit`);
  }

  if (!next && isReverse) {
    hideFinalScreen();
    return;
  }

  if (!next && !isReverse) {
    MicroModal.close(`values-modal`);
    return;
  }

  if (isReverse) {
    changeFinalValues(current, next, true).then(() => {
      buttonNextFinal.onclick = () => iterateFinalValues(values, finalValueIndex - 1, false);
      buttonPrevFinal.onclick = () => iterateFinalValues(values, finalValueIndex - 1, true);
      buttonNextFinal.disabled = false;
      buttonPrevFinal.disabled = false;
    });
    return;
  }

  changeFinalValues(current, next).then(() => {
    buttonNextFinal.onclick = () => iterateFinalValues(values, finalValueIndex + 1, false);
    buttonPrevFinal.onclick = () => iterateFinalValues(values, finalValueIndex + 1, true);
    buttonNextFinal.disabled = false;
    buttonPrevFinal.disabled = false;
  });
};

const iterateValues = (values, valueIndex, isReversed = false) => {

  const iterateLists = (lists, pages, listIndex, isReverse = false) => {

    const step = isReverse ? -1 : 1;
    const nextIndex = isReverse ? listIndex - 1 : listIndex + 1;
    const nextList = lists[nextIndex];
    const nextPage = pages[nextIndex];
    const currentList = lists[listIndex];
    const currentPage = pages[listIndex];
    const nextValueIndex = valueIndex + step;
    const nextValue = values[nextValueIndex];
    const currentFigure = currentValue.querySelector(FIGURE_CLASS);

    buttonNext.disabled = true;
    buttonPrev.disabled = true;

    if (valueIndex === 0 && nextIndex < 0) {
      MicroModal.close(`values-modal`);
    }

    if (!nextList) {
      if (!nextValue) {
        showFinalScreen();

        buttonNext.disabled = false;
        buttonPrev.disabled = false;

        return;
      }

      if (isReverse) {
        setStepOpacity(valueIndex, listsNumber, null);
      }

      setBarProgress(step);
      insertFigure(figuresList[nextValueIndex], nextValue);

      changeAnimation(ANIMATIONS.VALUES, valueIndex, nextValueIndex);
      changeValues(currentValue, nextValue, isReverse)
          .then(() => {
            const nextFigure = nextValue.querySelector(FIGURE_CLASS);
            return isReverse ? dismountFigure(currentFigure, listIndex) : buildFigure(nextFigure, 0);
          });
      iterateValues(values, nextValueIndex, isReverse);
      return;
    }

    setBarProgress(step);
    setStepOpacity(valueIndex, listsNumber, isReverse ? listIndex - 1 : listIndex + 1);
    setButtonProgress(nextIndex, listsNumber);

    changePages(currentPage, nextPage);
    changeLists(currentList, nextList).then(() => {
      showListContents(nextList);
    }).then(() => {
      if (isReverse) {
        dismountFigure(currentFigure, listIndex);
      } else {
        buildFigure(currentFigure, nextIndex);
      }
    });

    buttonNext.onclick = () => iterateLists(lists, pages, nextIndex, false);
    buttonPrev.onclick = () => iterateLists(lists, pages, nextIndex, true);
  };

  const currentValue = values[valueIndex];

  const currentValueLists = currentValue.querySelectorAll(DETAILS_LIST_CLASS);
  const listsNumber = currentValueLists.length;

  setStepOpacity(valueIndex, listsNumber, isReversed ? listsNumber - 1 : 0);
  setButtonProgress(isReversed ? listsNumber - 1 : 0, listsNumber);
  const pages = createPagination(listsNumber, isReversed);

  const listIndex = isReversed ? listsNumber - 1 : 0;

  buttonNext.onclick = () => iterateLists(currentValueLists, pages, listIndex, false);
  buttonPrev.onclick = () => iterateLists(currentValueLists, pages, listIndex, true);
};

const toggleClass = (element, className) => {
  if (element.classList.contains(className)) {
    element.classList.remove(className);
  } else {
    element.classList.add(className);
  }
};

export const prepValues = () => {
  hideLists(lists);
  hide(values);
  hide(headings);
  hide(finalValueItems);
  hide(finalTexts);

  toggleClass(progressBar, HIDDEN);
  toggleClass(controls, HIDDEN);
  toggleClass(controlsFinal, HIDDEN);
  toggleClass(progressList, HIDDEN);
};

const setupValues = () => {
  buttonNext.disabled = true;
  buttonPrev.disabled = true;

  iterateValues(values, 0);

  values[0].insertAdjacentHTML(`afterbegin`, figuresList[0]);
  const figure = values[0].querySelector(FIGURE_CLASS);

  changeAnimation(ANIMATIONS.VALUES, 0);

  setTimeout(() => {
    animateCSS(values[0], `slideInDown faster`, true)
        .then(() => animateCSS(progressBar, `slideInLeft faster`, true))
        .then(() => Promise.all([
          animateCSS(progressList, `fadeIn faster`, true),
          animateCSS(controls, `fadeIn faster`, true)
        ]))
        .then(() => {
          showHeading(firstValueHeading);
          toggleClass(lists[0], HIDDEN);
          showListContents(lists[0]);
        })
        .then(() => buildFigure(figure, 0));
  }, 2000);
};

const firstValue = document.querySelector(FIRST_VALUE_SELECTOR);
const firstValueHeading = firstValue.querySelector(`h3`);
const values = document.querySelectorAll(VALUE_ITEM_CLASS);
const lists = document.querySelectorAll(DETAILS_LIST_CLASS);
const controls = document.querySelector(CONTROLS_CLASS);
const controlsFinal = document.querySelector(CONTROLS_FINAL_CLASS);
const buttonNext = controls.querySelector(BUTTON_NEXT_CLASS);
const buttonPrev = controls.querySelector(BUTTON_PREV_CLASS);
const buttonNextFinal = controlsFinal.querySelector(BUTTON_NEXT_FINAL_CLASS);
const buttonPrevFinal = controlsFinal.querySelector(BUTTON_PREV_FINAL_CLASS);
const finalValueItems = document.querySelectorAll(FINAL_ITEM_CLASS);
const valuesScreen = document.querySelector(`${MODAL_CONTENT_CLASS}${VALUES}`);
const finalScreen = document.querySelector(`${MODAL_CONTENT_CLASS}${FINAL}`);
const progressCircle = document.querySelector(PROGRESS_CIRCLE_CLASS);
const progressList = document.querySelector(PROGRESS_CLASS);
const progressItems = document.querySelectorAll(PROGRESS_ITEM_CLASS);
const progressBar = document.querySelector(PROGRESS_BAR_CLASS);
const headings = document.querySelectorAll(HEADING_CLASS);
const finalTexts = document.querySelectorAll(FINAL_TEXT_CLASS);
let activeAnimation = [];
let activeAnimationFinal = [];
let finalItems = false;

export default setupValues;
